import { LoginView } from './LoginView'
import { useAppSelector } from '../../hooks'
import { RootState } from '../../store'

export const Login = () => {
    const loginSlice = useAppSelector((state: RootState) => state.login)
    return <LoginView error={loginSlice.error} />
}
